import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import { massUnitField } from './common/sharedFields';
import {
  applicationOfCascadingPrincipleField,
  isSecondaryField,
  materialField,
  materialWeightField,
  isBiologicalField,
  orgRawMaterialField,
  sustainableSourcingSchemeField,
} from './common/consumerGoodsFields';

export const consumerGoodsMaterialAssessmentMetadata = {
  displayName: msg({
    message: 'Purchased materials: Watershed library',
    context:
      'Activity data schema name for purchased materials: Watershed library',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    application_of_cascading_principle: applicationOfCascadingPrincipleField,
    fabric_construction: {
      displayName: msg({
        message: 'Fabric construction',
        context: 'Fabric construction of the material.n',
      }),
      externalDescription: msg({
        message: 'Fabric construction of the material.',
        context: 'Fabric construction',
      }),
    },
    is_biological: isBiologicalField,
    is_secondary: isSecondaryField,
    loss_rate_percent: {
      displayName: msg({
        message: 'Loss rate percent',
        context:
          'The percentage of material lost due to manufacturing processes.',
      }),
      externalDescription: msg({
        message:
          'The percentage of material lost due to manufacturing processes.',
        context: 'Loss rate percent',
      }),
    },
    org_material: materialField,
    org_raw_material: orgRawMaterialField,
    quantity: materialWeightField,
    sustainable_sourcing_scheme: sustainableSourcingSchemeField,
    unit: massUnitField,
    yarn_size: {
      displayName: msg({
        message: 'Yarn size',
        context: 'Yarn size in decitex (dtex)',
      }),
      externalDescription: msg({
        message: 'Yarn size in decitex (dtex)',
        context: 'Yarn size',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
